import { render, staticRenderFns } from "./cadastro_credito.vue?vue&type=template&id=33c5e763"
import script from "./cadastro_credito.vue?vue&type=script&lang=js"
export * from "./cadastro_credito.vue?vue&type=script&lang=js"
import style0 from "./cadastro_credito.vue?vue&type=style&index=0&id=33c5e763&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports